(() => {
  const input = document.querySelector('#rv-search');
  const results = document.querySelector('#rv-predictive');
  let timer, controller;
  const close = () => { if (results) results.hidden = true; input?.setAttribute('aria-expanded', 'false'); };
  input?.addEventListener('input', () => {
    clearTimeout(timer); controller?.abort();
    const query = input.value.trim();
    if (query.length < 2) { close(); return; }
    timer = setTimeout(async () => {
      controller = new AbortController();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`, { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        results.replaceChildren();
        for (const product of data.resources.results.products) {
          const link = document.createElement('a'); link.href = product.url;
          if (product.image) { const image = document.createElement('img'); image.src = product.image; image.alt = ''; image.width = 44; image.height = 44; link.append(image); }
          const title = document.createElement('span'); title.textContent = product.title.replace(/2ed/ig, ''); link.append(title); results.append(link);
        }
        results.hidden = !results.children.length; input.setAttribute('aria-expanded', String(!results.hidden));
      } catch (error) { if (error.name !== 'AbortError') close(); }
    }, 180);
  });
  input?.addEventListener('keydown', event => { if (event.key === 'Escape') close(); if (event.key === 'ArrowDown') { event.preventDefault(); results.querySelector('a')?.focus(); } });
  document.addEventListener('click', event => { if (!event.target.closest('.cauta-box')) close(); });
  document.querySelectorAll('[data-rv-recommendations]').forEach(async element => {
    try {
      const response = await fetch(element.dataset.url); if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector(`[data-rv-recommendations="${element.dataset.rvRecommendations}"]`);
      if (content?.querySelector('.card')) element.innerHTML = content.innerHTML;
    } catch (_) { /* Keep server-rendered collection fallback. */ }
  });
  const sticky = document.querySelector('[data-rv-sticky]');
  const footer = document.querySelector('.foot');
  if (sticky && footer) {
    new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }).observe(footer);
    document.querySelector('[data-rv-variant]')?.addEventListener('change', event => {
      const available = event.target.selectedOptions[0].dataset.available === 'true';
      sticky.disabled = !available; sticky.textContent = available ? 'Adaugă în coș' : 'Indisponibil';
    });
  }
})();

(() => {
  const brand = document.querySelector('[data-rv-brand-select]');
  if (brand) {
    const cards = [...document.querySelectorAll('.rv-results .card')];
    const vendors = [...new Set(cards.map(card => card.dataset.vendor).filter(Boolean))].sort();
    for (const vendor of vendors) brand.add(new Option(vendor, vendor));
    brand.parentElement.hidden = !vendors.length;
    brand.addEventListener('change', () => { for (const card of cards) card.hidden = !!brand.value && card.dataset.vendor !== brand.value; });
  }
  document.querySelector('.rv-sort')?.addEventListener('submit', event => {
    for (const [key, value] of new URLSearchParams(location.search)) {
      if (!key.startsWith('filter.')) continue;
      const hidden = document.createElement('input'); hidden.type='hidden'; hidden.name=key; hidden.value=value; event.target.append(hidden);
    }
  });
})();

// Compact mobile header; preserve the original native product search form.
(() => {
 const toggle=document.querySelector('[data-rv-search-toggle]');
 toggle?.addEventListener('click',()=>{const header=toggle.closest('.head');const open=header.classList.toggle('rv-search-open');toggle.setAttribute('aria-expanded',String(open));if(open)header.querySelector('#rv-search')?.focus();});
})();
